import styled from 'styled-components';

export const InboxStyle = styled.div``